import { get, post, patch, del } from './client.js';

/* Platform-wide license management (SA-only) */
export const list = (params) => {
  const q = params ? '?' + new URLSearchParams(params).toString() : '';
  return get(`/platform/licenses${q}`);
};

export const getOne = (licenseId) => get(`/platform/licenses/${licenseId}`);
export const create = (orgId, body) => post(`/platform/orgs/${orgId}/licenses`, body);
export const update = (licenseId, body) => patch(`/platform/licenses/${licenseId}`, body);
export const renew = (licenseId) => post(`/platform/licenses/${licenseId}/renew`, {});
export const remove = (licenseId) => del(`/platform/licenses/${licenseId}`);

/* Org-scoped license view (OA) */
export const listByOrg = (orgId) => get(`/orgs/${orgId}/licenses`);
export const getCurrent = (orgId) => get(`/orgs/${orgId}/licenses/current`);
export const getHistory = (orgId) => get(`/orgs/${orgId}/licenses/history`);
export const renewOrg = (orgId, months) => post(`/orgs/${orgId}/licenses/renew`, { months });
export const addSeats = (orgId, seats) => post(`/orgs/${orgId}/licenses/seats/add`, { seats });
export const removeSeats = (orgId, seats) => post(`/orgs/${orgId}/licenses/seats/remove`, { seats });
export const allocateWorkspace = (orgId, workspaceId) => post(`/orgs/${orgId}/licenses/workspaces/${workspaceId}/allocate`, {});
